var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolderC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "25px",
    height: "25px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#64ffda",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,11c-1.93,0 -3.5,1.57 -3.5,3.5v21c0,1.93 1.57,3.5 3.5,3.5h25c1.93,0 3.5,-1.57 3.5,-3.5v-18c0,-1.93 -1.57,-3.5 -3.5,-3.5h-15c-0.538,0 -1.071,-0.178 -1.5,-0.5l-2.40039,-1.80078c-0.601,-0.451 -1.34661,-0.69922 -2.09961,-0.69922zM12.5,12h4c0.538,0 1.07,0.178 1.5,0.5l2.40039,1.80078c0.601,0.451 1.34661,0.69922 2.09961,0.69922h15c1.378,0 2.5,1.122 2.5,2.5v1.5h-30v-4.5c0,-1.378 1.122,-2.5 2.5,-2.5zM10,20h30v15.5c0,1.378 -1.122,2.5 -2.5,2.5h-25c-1.378,0 -2.5,-1.122 -2.5,-2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderC);
export default __webpack_public_path__ + "static/media/icon-folderC.e92d588584444e262a488499afa0ecbc.svg";
export { ForwardRef as ReactComponent };